var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-nav-item-dropdown",
    { attrs: { right: "", "no-caret": "" } },
    [
      _c(
        "template",
        { slot: "button-content" },
        [
          _c("i", { staticClass: "icon-list" }),
          _c("b-badge", { attrs: { pill: "", variant: "warning" } }, [
            _vm._v(_vm._s(_vm.itemsCount))
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-dropdown-header",
        { staticClass: "dropdown-menu-lg text-center", attrs: { tag: "div" } },
        [
          _c("strong", [
            _vm._v("You have " + _vm._s(_vm.itemsCount) + " pending tasks")
          ])
        ]
      ),
      _vm._v(" "),
      _c("b-dropdown-item", [
        _c("div", { staticClass: "small mb-0" }, [
          _vm._v("Task One"),
          _c("span", { staticClass: "float-right" })
        ])
      ]),
      _vm._v(" "),
      _c("b-dropdown-item", [
        _c("div", { staticClass: "small mb-0" }, [
          _vm._v("Task Two"),
          _c("span", { staticClass: "float-right" })
        ])
      ]),
      _vm._v(" "),
      _c("b-dropdown-item", [
        _c("div", { staticClass: "small mb-0" }, [
          _vm._v("Task Three"),
          _c("span", { staticClass: "float-right" })
        ])
      ]),
      _vm._v(" "),
      _c("b-dropdown-item", [
        _c("div", { staticClass: "small mb-0" }, [
          _vm._v("Task Four"),
          _c("span", { staticClass: "float-right" })
        ])
      ]),
      _vm._v(" "),
      _c("b-dropdown-item", [
        _c("div", { staticClass: "small mb-0" }, [
          _vm._v("Task Five"),
          _c("span", { staticClass: "float-right" })
        ])
      ]),
      _vm._v(" "),
      _c("b-dropdown-item", { staticClass: "text-center" }, [
        _c("strong", [_vm._v("Open Task List")])
      ])
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-75d55604", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-75d55604","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Header/HeaderDropdownTasks.vue
// module id = 1415
// module chunks = 0